import { render } from "./indexheader.vue?vue&type=template&id=079dd85c"
import script from "./indexheader.vue?vue&type=script&lang=js"
export * from "./indexheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__